var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavoriteStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.123 2.003a9.72 9.72 0 00-7.17 3.62 9.72 9.72 0 00-7.17-3.62 8.59 8.59 0 00-6.76 3 9.56 9.56 0 00-1.83 7.79c.61 3.51 4.79 8.54 12.44 15 1 .82 1.92 1.57 2.71 2.18a1 1 0 00.62.21 1.05 1.05 0 00.62-.21c.78-.63 1.71-1.37 2.7-2.19 7.64-6.45 11.82-11.48 12.43-14.99a9.55 9.55 0 00-1.89-7.79 8.56 8.56 0 00-6.7-3zm6.62 10.45c-.51 2.95-4.72 7.83-11.72 13.75-.73.6-1.42 1.17-2.05 1.67l-2-1.66c-7.13-5.93-11.3-10.81-11.81-13.76a7.59 7.59 0 011.43-6.21 6.51 6.51 0 015.19-2.24c2.24 0 4.59 1.39 6.37 3.8a1 1 0 001.258.3 1 1 0 00.352-.3c1.77-2.41 4.08-3.8 6.36-3.8a6.55 6.55 0 015.18 2.23 7.63 7.63 0 011.44 6.22z"
  })));
}

export default SvgFavoriteStroke;